import React from 'react';
import { withModals } from '../Modal/withModals';
import { setWindowConfiguration } from './FlowWebInternal';
function _ModalHost(props) {
  React.useEffect(function () {
    setWindowConfiguration(props.instanceSymbol, {
      showModal: props.showModal
    });
  }, [props.instanceSymbol, props.showModal]);
  return null;
}
export var ModalHost = withModals(_ModalHost);